export default "<div *ngFor=\"let e of errors\" class=\"notification is-danger\">\n  {{'errors.messages.' + e.error | translate:e.params}}\n</div>\n"